const quizzMixin = {
  computed: {
    currentQuestion () {
      return this.questions[this.questionIndex]
    },
    currentQuestionLabel () {
      return `${this.currentQuestion.question} :`
    },
    score () {
      return this.questions.filter(question => question.status === 'right').length
    }
  },
  methods: {
    setQuestionStatus (status) {
      this.currentQuestion.status = status
    },
    nextQuestion () {
      if (this.questionIndex !== this.questions.length - 1) {
        this.questionIndex++
      } else {
        this.$store.commit('setQuizzScore', this.score)
        this.$store.dispatch('next')
      }
    }
  }
}

export default quizzMixin
